export default __webpack_public_path__ + "static/media/FlechaBoton1.21fedc62.svg";